<template>
  <div class="content">
    <!-- 开户按钮 -->
    <el-form :inline="true" class="demo-form-inline" size="small">
      <el-form-item label="手机号: " style="margin-left: 20px">
        <el-input
          v-model="selectForm.supplier_phone"
          placeholder="请输入手机号"
          style="width: 250px"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="身份: ">
        <el-select v-model="selectForm.roleId" placeholder="请选择" clearable>
          <div v-for="item in adminArr" :key="item.id">
            <el-option :label="item.name" :value="item.id"></el-option>
          </div>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="selectData">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="kaihuBtn">开户</el-button>
      </el-form-item>
    </el-form>
    <!-- 商品表格 -->
    <el-table
      border
      :data="beforArr"
      style="width: 100%; overflow-y: scroll"
      height="calc(100vh - 220px)"
      v-loading="loading"
    >
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
      <!-- <el-table-column label="用户id" width="80" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.userId }}</span>
          </template>
      </el-table-column>-->
      <el-table-column label="账号类型" align="center" width="130">
        <template slot-scope="scope">
          <el-tag size="medium">
            {{
            scope.row.roleId == 0
            ? "管理员账号"
            : scope.row.roleId == 1
            ? "药店"
            : scope.row.roleId == 2
            ? "检测机构"
            : scope.row.roleId == 3
            ? "医生"
            : scope.row.roleId == 4
            ? "推广员"
            : scope.row.roleId == 5
            ? "客服"
            : "-"
            }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="账号名" width="150" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.sup_username }}</span>
        </template>
      </el-table-column>
      <el-table-column label="账号密码" width="100" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.sup_password }}</span>
        </template>
      </el-table-column>

      <el-table-column label="手机号" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.supplier_phone }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="日期" align="center" width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.create_time }}</span>
        </template>
      </el-table-column>-->
      <el-table-column label="备注">
        <template slot-scope="scope">
          <span>{{ scope.row.message }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="320" align="center">
        <template slot-scope="scope">
          <el-button size="mini" @click="ejectupdateGoods(scope.row)">修改</el-button>
          <el-button size="mini" type="danger" @click="deleteAdmin(scope.row)">删除</el-button>
          <el-button
            size="mini"
            type="success"
            @click="handleCreateCode(scope.row)"
            style="margin: 10px"
            v-if="scope.row.roleId == 1"
          >药店二维码</el-button>

          <el-button
            size="mini"
            type="success"
            @click="handleCreateCodeByInformation(scope.row)"
            style="margin: 10px"
            v-if="scope.row.roleId == 2"
          >检测机构二维码</el-button>
          <el-button
            size="mini"
            type="success"
            @click="handleCreateSaleCode(scope.row)"
            style="margin: 10px"
            v-if="scope.row.roleId == 4"
          >销售员推广二维码</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        @prev-click="prevClick"
        @next-click="nextClick"
        background
        layout="prev, pager, next"
        :page-size="pageSize"
        :total="pageCount"
    ></el-pagination>-->
    <!-- 开户表单 -->
    <el-dialog :title="inputTitle" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form :model="form">
        <!-- <el-form-item label="用户id">
          <el-input v-model="form.userId" auto-complete="off"></el-input>
        </el-form-item>-->
        <el-form-item label="用户名">
          <el-input v-model="form.sup_username" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="form.sup_password" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="form.supplier_phone" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="账号类型">
          <el-select v-model="form.roleId" placeholder="请选择用户账号类型" @change="roleChange">
            <div v-for="item in adminArr" :key="item.id">
              <el-option :label="item.name" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="店铺" v-if="form.roleId == 1">
          <el-select v-model="form.storeId" placeholder="请选择用户账号类型">
            <div v-for="item in storeList" :key="item.id">
              <el-option :label="item.storeName" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>-->

        <el-form-item label="备注(客户公司名称或姓名)">
          <el-input v-model="form.message" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbmitBtn">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 检测机构二维码 -->
    <el-dialog title="检测机构二维码" :visible.sync="dialogCodeVisible" :close-on-click-modal="false">
      <el-form :model="CodeForm">
        <el-form-item label="用户名">
          <el-input v-model="form.sup_username" auto-complete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="检测工具商品ID">
          <el-input v-model="CodeForm.pid" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogCodeVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbmitCodeBtn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  selectspuser,
  addspuser,
  updatespuser,
  deletespuser
} from "@/services/system/admin";
import { createCode } from "@/services/system/getCode.js";

export default {
  data() {
    return {
      selectForm: {
        roleId: ""
      },
      beforArr: [],
      inputTitle: "开户",
      loading: true,
      name: "",
      pageCount: "",
      pageSize: 8,
      adminArr: [
        { name: "管理员账号", id: "0" },
        { name: "药店(商城)", id: "1" },
        { name: "检测机构(检测)", id: "2" },
        { name: "医生(问答)", id: "3" },
        { name: "推广员", id: "4" },
        { name: "客服", id: "5" }
      ],
      storeList: [],
      form: {},
      dialogFormVisible: false,
      CodeForm: {},
      dialogCodeVisible: false
    };
  },
  created() {

    this.selectData();
  },
  methods: {
    // 查询
    selectData() {
      selectspuser({
        ...this.selectForm
      }).then(resp => {
        this.loading = false;
        this.beforArr = resp;
        // this.$message({
        //   type: "success",
        //   message: "跟新成功!"
        // });
        // this.pageCount = resp.pageCount;
      });
    },
    // 开户按钮
    kaihuBtn() {
      this.inputTitle = "开户";
      this.dialogFormVisible = true;
      this.form = {
        roleId: "0"
      };
    },
    ejectupdateGoods(row) {
      this.dialogFormVisible = true;
      this.inputTitle = "修改";
      this.form = JSON.parse(JSON.stringify(row));
    },
    roleChange() {
      this.form.storeId = null;
    },

    // 表单提交按钮
    sumbmitBtn() {
      console.log(this.form);
      //    if (this.form.userId == ''||this.form.userId == null) {
      //   this.$message.error("请填写用户id（很重要！）");
      //   return;
      // }
      if (this.form.sup_username == "" || this.form.sup_username == null) {
        this.$message.error("请填写用户名");
        return;
      }
      if (this.form.sup_password == "" || this.form.sup_password == null) {
        this.$message.error("请填写密码");
        return;
      }
      if (this.form.supplier_phone == "" || this.form.supplier_phone == null) {
        this.$message.error("请填写手机号");
        return;
      }
      if (this.form.roleId == null) {
        this.$message.error("请选择账号类型");
        return;
      }
      if (this.form.message == "" || this.form.message == null) {
        this.$message.error("请填写备注");
        return;
      }
      if (this.inputTitle == "开户") {
        addspuser(this.form).then(res => {
          if (res.code == 200) {
            this.dialogFormVisible = false;
            this.$message({
              type: "success",
              message: "开通账号成功!"
            });
            this.selectData();
          } else {
            this.$message({
              type: "info",
              message: res.data
            });
          }
        });
        return;
      }

      updatespuser(this.form).then(res => {
        if (res.code == 200) {
          this.dialogFormVisible = false;
          this.$message({
            type: "success",
            message: "修改账号成功!"
          });
          this.selectData();
        } else {
          this.$message({
            type: "info",
            message: res.data
          });
        }
      });
    },

    /* 机构检测二维码弹窗 */
    handleCreateCodeByInformation(row) {
      this.dialogCodeVisible = true;
      this.form = JSON.parse(JSON.stringify(row));
    },

    sumbmitCodeBtn() {
      if (!this.CodeForm.pid) {
        this.$message.error("请填写信息");
        return;
      }
      this.handleCreateCode({
        id: this.form.id,
        roleId: this.form.roleId,
        pid: this.CodeForm.pid
      });
      this.dialogCodeVisible = false;
      this.CodeForm = {};
    },

    /* 药店二维码 */
    handleCreateCode(row) {
      createCode({
        admin_id: row.id,
        pid: row.pid,
        roleId: row.roleId
      }).then(res => {
        if (res.code === 200) {
          this.$message({
            type: "success",
            message: "创建成功,前往下载!"
          });

          setTimeout(() => {
            window.open(res.data, "_blank");
          }, 1000);
        } else {
          this.$message({
            type: "error",
            message: res.data
          });
        }
      });
    },

    /* 销售二维码 */
    handleCreateSaleCode(row) {
      createCode({
        admin_id: row.id,
        phone: row.supplier_phone,
        roleId: row.roleId
      }).then(res => {
        if (res.code === 200) {
          this.$message({
            type: "success",
            message: "创建成功,前往下载!"
          });

          setTimeout(() => {
            window.open(res.data, "_blank");
          }, 1000);
        } else {
          this.$message({
            type: "error",
            message: res.data
          });
        }
      });
    },

    // 删除
    deleteAdmin(row) {
      this.$confirm("此操作将永久删除该账号, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          console.log(row.id);
          deletespuser(row.id).then(resp => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.selectData();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  }
};
</script>

<style>
.content {
  margin: 10px auto;
  width: 98%;
}
.demo-form-inline {
  margin: 20px 0 0;
}
.el-pagination {
  text-align: center;
  margin: 20px;
}
.userNanme:hover {
  cursor: pointer;
}
</style>
